import learningPages from "../../../config/content/public_learning.json";

export const BRAND = "αβΓ✻1";
export const TITLE_SEP = "·";

const SLUGS: Record<string, string> = {
  ...Object.fromEntries(
    learningPages.flatMap((page) => [
      [page.path, page.title],
      [`/zh-CN${page.path}`, page.title_zh],
    ]),
  ),
  "/philosophy": "philosophy",
  "/about": "about",
  "/safety": "safety",
  "/privacy": "privacy",
  "/terms": "terms",
  "/purchase": "membership",
  "/login": "login",
  "/home": "workspace",
  "/workspace": "workspace",
  "/workspace/workbench": "workbench",
  "/workspace/workbench/build": "simulator",
  "/workspace/workbench/monitor": "monitor",
  "/workspace/workbench/model": "manifold",
  "/workspace/explore": "explore",
  "/workspace/explore/quiz": "daily-quiz",
  "/workspace/me/compound": "compound",
  "/workspace/library": "library",
  "/workspace/me/library": "library",
  "/workspace/me": "profile",
  "/workspace/me/inbox": "inbox",
  "/workspace/settings": "settings",
  "/workspace/build": "workspace",
  "/workspace/build/edit": "simulator",
  "/workspace/strategy-center/simulator": "simulator",
  "/workspace/build/manifold": "manifold",
  "/workspace/positions": "positions",
  "/workspace/profile/settings": "settings",
  "/workspace/admin": "admin",
  "/manifold": "manifold",
  "/theta-nets": "theta-nets",
  "/backtests": "backtests",
  "/journal": "journal",
  "/library": "library",
  "/alerts": "alerts",
  "/daily-quiz": "daily-quiz",
  "/transactions": "transactions",
  "/guide": "guide",
  "/settings": "settings",
  "/admin": "admin",
  "/simulator": "simulator",
};

export function slugForPath(path: string): string | null {
  if (!path || path === "/") return null;
  if (SLUGS[path]) return SLUGS[path];
  const prefix = Object.keys(SLUGS)
    .filter((k) => path.startsWith(`${k}/`))
    .sort((a, b) => b.length - a.length)[0];
  return prefix ? SLUGS[prefix] : null;
}

export function buildTitle(suffix?: string | null): string {
  return suffix ? `${BRAND} ${TITLE_SEP} ${suffix}` : BRAND;
}
